import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let context_path = process.env.VUE_APP_CONTEXT_PATH;

const router= new Router({
  mode: "history",
  routes: [
    {
      path: "/member/management",
      name: "membersManagement",
      component: () => import("./views/members/membersManagementView")
    },
    {
      path: "/member/add",
      name: "memberAdd",
      component: () => import("./views/members/membersFormView")
    },
    {
      path: "/member/edit/:id",
      name: "memberEdit",
      component: () => import("./views/members/membersFormView")
    },
    {
      path: "/member/:id/licenses",
      name: "memberLicenses",
      component: () => import("./views/members/memberLicensesView")
    },
    {
      path: "/member/:id/trainings",
      name: "memberTrainings",
      component: () => import("./views/members/memberTrainingsView")
    },
    {
      path: "/member/:id/disciplinary",
      name: "memberDisciplinaryComments",
      component: () => import("./views/members/membersDisciplinaryCommentsView")
    },
    {
      path: "/member/:id/honours",
      name: "memberHonours",
      component: () => import("./views/members/membersHonoursView")
    },
    {
      path: "/unit/management",
      name: "unitManagement",
      component: () => import("./views/unit/unitManagementView")
    },
    {
      path: "/unit/add",
      name: "unitAdd",
      component: () => import("./views/unit/unitManagementView")
    },
    {
      path: "/billing-method/management",
      name: "billingMethodManagement",
      component: () => import("./views/unit/billingMethodManagementView")
    },
    {
      path: "/census/history",
      name: "censusHistory",
      component: () => import("./views/census/censusHistoryView")
    },
    {
      path: "/census/submit",
      name: "censusSubmit",
      component: () => import("./views/census/censusSubmitView")
    },
    {
      path: "/census/add",
      name: "censusAdd",
      component: () => import("./views/census/censusAddView")
    },
    {
      path: "/licenses/pending",
      name: "licensesPending",
      component: () => import("./views/licenses/licensesPendingView")
    },
    {
      path: "/licenses/add",
      name: "addLicense",
      component: () => import("./views/licenses/licensesAddView")
    },
    {
      path: "/licenses/proposal/:id",
      name: "acceptLicenseProposal",
      component: () => import("./views/licenses/licenseProposalAcceptView")
    },
    {
      path: "/licenses/active",
      name: "licensesActive",
      component: () => import("./views/licenses/licensesActiveView")
    },
    {
      path: "/support/active",
      name: "supportActive",
      component: () => import("./views/support/supportActiveView")
    },
    {
      path: "/support/add",
      name: "supportAdd",
      component: () => import("./views/support/supportAddView")
    },
    {
      path: "/support/pending",
      name: "supportPending",
      component: () => import("./views/support/supportPendingView")
    },
    {
      path: "/conference",
      name: "conferenceView",
      component: () => import("./views/conference/conferenceView")
    },
    {
      path: "/jamboree",
      name: "jamboreeView",
      component: () => import("./views/jamboree/jamboreeManagementView")
    },
    {
      path: "/jamboree/payment/list",
      name: "jamboreePaymentTableView",
      component: () => import("./views/jamboree/jamboreePaymentTableView")
    },
    {
      path: "/jamboree/application/list",
      name: "jamboreeApplicationTableView",
      component: () => import("./views/jamboree/jamboreeApplicationTableView")
    },
    {
      path: "/jamboree/application/:id",
      name: "jamboreeApplicationEditView",
      component: () => import("./views/jamboree/jamboreeApplicationEditView")
    },
    {
      path: "/jamboree/application",
      name: "jamboreeApplicationAddView",
      component: () => import("./views/jamboree/jamboreeApplicationAddView")
    },
    {
      path: "/jamboree/payment/:id",
      name: "jamboreePaymentEditView",
      component: () => import("./views/jamboree/jamboreePaymentEditView")
    },
    {
      path: "/jamboree/payment",
      name: "jamboreePaymentAddView",
      component: () => import("./views/jamboree/jamboreePaymentAddView")
    },
    {
      path: "/reports/census",
      name: "reportsCensus",
      component: () => import("./views/reports/reportsCensusView")
    },
    {
      path: "/reports/members",
      name: "reportsMembers",
      component: () => import("./views/reports/reportsMembersView")
    },
    {
      path: "/reports/licenses",
      name: "reportsLicenses",
      component: () => import("./views/reports/reportsLicensesView")
    },
    {
      path: "/reports/license-proposals",
      name: "reportsLicenseProposals",
      component: () => import("./views/reports/reportsLicenseProposalsView")
    },
    {
      path: "/reports/default",
      name: "defaultReport",
      component: () => import("./views/reports/reportsDefaultView")
    },
    {
      path: "/reports/units",
      name: "reportsUnits",
      component: () => import("./views/reports/reportsUnitsView")
    },
    {
      path: "/reports/support",
      name: "reportsSupport",
      component: () => import("./views/reports/reportsSupportView")
    },
    {
      path: "/reports/oldMembers",
      name: "reportsOldMembers",
      component: () => import("./views/reports/reportsOldMembersView")
    },
    {
      path: "/reports/censusTotal",
      name: "reportsCensusTotal",
      component: () => import("./views/reports/reportsCensusTotalView")
    },
    {
      path: "/reports/memberCensusHistory",
      name: "reportsMemberCensusHistory",
      component: () => import("./views/reports/reportsMemberCensusHistoryView")
    },
    {
      path: "/reports/electionEligible",
      name: "reportsElectionEligible",
      component: () => import("./views/reports/reportsElectionEligibleView")
    },
    {
      path: "/reports/trainingProfiles",
      name: "reportsTrainingProfiles",
      component: () => import("./views/reports/reportsTrainingProfilesView")
    },
    {
      path: "/reports/trainings",
      name: "reportsTrainings",
      component: () => import("./views/reports/reportsTrainingsView")
    },
    {
      path: "/reports/trainingParticipations",
      name: "reportsTrainingParticipations",
      component: () => import("./views/reports/reportsTrainingParticipationsView")
    },
    {
      path: "/reports/trainingWoodBadge",
      name: "reportsTrainingWoodBadge",
      component: () => import("./views/reports/reportsTrainingWoodBadgeView")
    },
    {
      path: "/reports/trainingTrainers",
      name: "reportsTrainingTrainers",
      component: () => import("./views/reports/reportsTrainingTrainersView")
    },
    {
      path: "/reports/conference",
      name: "reportsConference",
      component: () => import("./views/reports/reportsConferenceView")
    },
    {
      path: "/reports/apply_activities",
      name: "reportsTrainingApplyActivities",
      component: () => import("./views/reports/reportsTrainingApplyActivitiesView")
    },
    {
      path:"/reports/achievement",
      name: "reportsAchievement",
      component: () => import ("./views/reports/reportsAchievementView")
    },
    {
      path: "/reports/evaluation_criterias",
      name: "reportsEvaluationCriterias",
      component: () => import("./views/reports/reportsEvaluationCriteriaView")
    },
    {
      path: "/reports/jamboree",
      name: "reportsJamboree",
      component: () => import("./views/reports/reportsJamboreeView")
    },
    {
      path: "/reports/jamboree_payment",
      name: "reportsJamboreePayments",
      component: () => import("./views/reports/reportsJamboreePaymentView")
    },
    {
      path: "/reports/trainingNeeds",
      name: "reportsTrainingNeeds",
      component: () => import("./views/reports/reportsTrainingNeedsView")
    },
    {
      path: "/reports/excursions",
      name: "reportsExcursion",
      component: () => import("./views/reports/reportsExcursionView")
    },
    {
      path: "/reports/users",
      name: "reportsUsers",
      component: () => import("./views/reports/reportsUsersView")
    },
    {
      path: "/reports/honours",
      name: "reportsMemberHonours",
      component: () => import("./views/reports/reportsMemberHonoursView")
    },


  ],
  base: context_path
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$keycloak.authenticated) {
      next()
    } else {
      const loginUrl = router.app.$keycloak.createLoginUrl()
      window.location.replace(loginUrl)
    }
  } else {
    next()
  }
})

export default router
